var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCarinaChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  className: "react-svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.7,9.3c0.4,0.4 0.4,1 0,1.4l-6,6c-0.2,0.2 -0.5,0.3 -0.7,0.3c-0.2,0 -0.5,-0.1 -0.7,-0.3l-6,-6c-0.4,-0.4 -0.4,-1 0,-1.4c0.4,-0.4 1,-0.4 1.4,0l5.3,5.3l5.3,-5.3c0.4,-0.4 1,-0.4 1.4,0"
})));
export default SvgCarinaChevron;